exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "employee-name{display:inline-block}employee-name span{text-transform:capitalize}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/components/employeeName/employeeName.scss
// module id = 1008
// module chunks = 0